import { ChevronIcon } from '@curology/ui-components-web/react/Icon/icons/ChevronIcon';
import clsx from 'clsx';
import { type ReactNode, useState } from 'react';
import React from 'react';

type AccordionProps = {
  children: ReactNode;
  className?: string;
  caption?: string;
  captionBody?: ReactNode;
  opened?: boolean;
  noBorder?: boolean;
  tabindex?: string;
};

const Accordion = (props: AccordionProps) => {
  const [toggle, setToggle] = useState(!!props.opened);
  const [width, setWidth] = React.useState(0);

  React.useEffect(() => {
    setWidth(window.innerWidth);
  }, [setWidth]);

  const accordionClasses = clsx(
    ` cur-w-full cur-flex cur-flex-row cur-justify-between cur-py-4 hover:cursor-pointer`,
    props.className,
  );

  return (
    <React.Fragment>
      <button className={accordionClasses} onClick={() => setToggle(!toggle)}>
        {props.caption && (
          <>
            <span>{props.caption}</span>
            <span
              className={` cur-flex-row-reverse cur-float-right cur-ml-auto cur-text-right cur-space-x-4 tw-space-x-reverse cur-transition-transform ${
                toggle ? 'cur-rotate-90' : ''
              }`}
            >
              <ChevronIcon className="cur-mr-2" name="chevron" size="md" />
            </span>
          </>
        )}
        {props.captionBody}
      </button>

      {width < 750 ? (
        <div className={`cur-overflow-hidden`}>
          <div
            className={`cur-flex cur-flex-col cur-w-full ${
              props.noBorder ? '' : 'border-t border-grayLighter'
            } transition-height `}
          >
            {toggle ? props.children : null}
          </div>
        </div>
      ) : (
        <div className={`cur-overflow-hidden`}>
          <div
            className={`cur-flex cur-flex-col cur-w-full ${
              props.noBorder ? '' : 'border-t border-grayLighter'
            } transition-height`}
          >
            {toggle ? props.children : null}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Accordion;
